/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { 
  Box, 
  Chip, 
  CircularProgress,  
  IconButton,  
  Menu,  
  MenuItem,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  TextField, 
  Tooltip, 
  Typography 
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';
import TopBar from '../../../../../components/utils/TopBar';

import global from "../../../../../global.scss";

const Data = {
  Direction: "QBD_LUSID",
  EntityTemplate: "CLASS"
};

const directionList = [
  { label: "QBD -> LUSID (be-accounting-tpi -> be-core)", value: "QBD_LUSID" }, 
  { label: "LUSID -> QBD (be-core -> be-accounting-tpi)", value: "LUSID_QBD" }
];

const entityList = [
  { label: "Class", value: "CLASS" }, 
  { label: "Account", value: "ACCOUNT" },
  { label: "Sales Tax", value: "SALES_TAX" },
  { label: "Item", value: "ITEM" },
  { label: "Vendor", value: "VENDOR" },
  { label: "Customer", value: "CUSTOMER" },
  { label: "Bill", value: "BILL" },
  { label: "Bill Payment", value: "BILL_PAYMENT" },
  { label: "Invoice", value: "INVOICE" },
  { label: "Invoice Payment", value: "INVOICE_PAYMENT" },
  { label: "Journal Entry", value: "JOURNAL_ENTRY" },
  { label: "Check", value: "CHECK" },
  { label: "Other", value: "OTHER" },
]

const PayloadInjectorPage = () => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.accounting-tpi.qbd"]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {

    } catch (err) {
      console.log(err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  
  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  return (
    <Box>

      <TopBar
        title={"Payload Injector"}
        button1Text="Add Operation"
        button1OnClick={() => {}}
        />

      <Box maxWidth={"sm"} className="modal">
        <Box width={"100%"}
          sx={{ padding: "15px"}}>
          {/* <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
            {title}
          </Typography> */}
          <Box 
            className="flexCenterSBRow"
            gap={"15px"}
            mb={"15px"}>
            <TextField
              label="Company Id"
              fullWidth 
              name="CompanyId"
              value={formData.CompanyId}
              onChange={handleChange}
              inputProps={{ maxLength: 255 }}
              />
          </Box>
          <Box 
            className="flexCenterSBRow"
            gap={"15px"}
            mb={"15px"}>
            <TextField
              select
              label="Direction"
              fullWidth 
              name="Direction"
              value={formData.Direction}
              onChange={handleChange}
              inputProps={{ maxLength: 255 }}>
              {
                directionList.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))
              }
            </TextField>
          </Box>
          <Box 
            className="flexCenterSBRow"
            gap={"15px"}
            mb={"15px"}>
            <TextField
              select
              label="Entity Template"
              fullWidth 
              name="EntityTemplate"
              value={formData.EntityTemplate}
              onChange={handleChange}
              inputProps={{ maxLength: 255 }}>
              {
                entityList.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))
              }
            </TextField>
          </Box>
          <Box 
            className="flexCenterSBRow"
            gap={"15px"}
            mb={"15px"}>
            <TextField 
              label="Payload"
              fullWidth 
              multiline
              minRows={5}
              maxRows={10}
              name="Payload"
              value={formData.Payload}
              onChange={handleChange}
              inputProps={{ maxLength: 255 }}
              />
          </Box>

        </Box>
        <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
          <LoadingButton 
            variant='contained'
            loading={loading}
            disabled={!(formData.ServiceCode !== "" && formData.FeeType !== "" && 
              formData.WhoPays !== "" && formData.Product !== "" &&
              formData.DeliveryMethod !== "" && formData.Plan !== ""
            )}
            onClick={() => {}}>
            Send
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  )
}

export default PayloadInjectorPage;